<template>
  <ubi-page-container class="ubi-panel">
    <!-- filtres -->
    <div v-if="hasAccessCalendar">
      <el-form @submit.prevent.native="doFilter">
        <ubi-panel style="background-color: #EBF3F2;">
          <ubi-search-container @resetfilter="resetfilterCalendar">
            <el-row :gutter="25">

              <el-col :lg="10">
                <!-- Search field -->
                <el-form-item :label="$t('planning.searchByTitle')">
                  <el-input
                      v-model="localFilters.search"
                      clearable
                      :placeholder="$t('planning.searchPlaceholder')"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :lg="10">
                <!-- Search field -->
                <el-form-item :label="$t('planning.typePost')">
                  <el-select v-model="localFilters.typePost" :placeholder="$t('planning.choiceTypePost')" clearable>
                    <el-option
                        v-for="item in showOptionsWithBv"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col class="mt-3">
                <el-row>
                  <el-col class="mb-2">
                    {{ $t('planning.searchByMonth')}}
                  </el-col>
                  <el-date-picker
                      v-model="monthSelected"
                      @change="setSelectedMonthToDates"
                      :clearable="false"
                      type="month"
                      :placeholder="$t('planning.selectedMonth')">
                  </el-date-picker>
                </el-row>
              </el-col>

              <el-col>
                <el-form-item style="margin-top: 25px;">
                  <el-radio-group v-model="localFilters.network">
                    <el-radio :label="null">{{ $t('planning.all') }}</el-radio>
                    <el-radio label="INSTAGRAM">{{ $t('planning.instagram') }}</el-radio>
                    <el-radio label="FACEBOOK">{{ $t('planning.facebook') }}</el-radio>
                    <el-radio label="GOOGLE">{{ $t('planning.gmb') }}</el-radio>
                    <el-radio label="LINKEDIN">{{ $t('planning.linkedin') }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>

            </el-row>
          </ubi-search-container>
        </ubi-panel>
      </el-form>
    </div>

    <!-- calendar -->
    <ubi-panel>
      <v-app v-if="hasAccessCalendar" >
        <v-row class="fill-height">
          <v-col>
            <v-sheet height="64" class="mb-6">
              <ToolbarCalendar
                  :today="today"
                  :getRefCalendar="() => $refs"
                  :type="type"
                  @setType="setType"
                  @setToday="setToday"
                  @prevClicked="prevClicked"
                  @nextClicked="nextClicked"
              />
            </v-sheet>

            <!-- Event dialog Component date time Picker -->
            <v-row justify="center">
              <v-dialog
                  @click:outside="closeDialog"
                  v-model="datetimeDialog"
                  width="290px"
              >
                <datetime-picker @updatedDateTime="updatedDateTime" :eventSelected="selectedEvent" @setType="setType"/>
              </v-dialog>
            </v-row>
            <!-- calendar -->
            <v-sheet height="600" width="960" >
              <v-calendar
                  class="calendar-loader"
                  ref="calendar"
                  color="#0AB1BF"
                  v-model="focus"
                  :events="getAllEvents"
                  locale="fr"
                  :event-margin-bottom="3"
                  :type="type"
                  :now="today"
                  @click:event="showEvent"
                  @click:more="viewDay"
                  @click:date="viewDay"
              >
              </v-calendar>
              <div class="wait-calendar-events" v-if="getIsLoading">
                <div class="text-loading-and-loader">
                  <DoubleBounce />
                  <p>{{ $t('general.calendar.loaderMessageCalendar')}}</p>
                </div>
              </div>
              <v-menu
                  v-model="selectedOpen"
                  :close-on-content-click="false"
                  :activator="selectedElement"
                  :key="selectedEvent.id"
                  open-on-focus
              >
                <CardModalCalendar
                    :events="getAllEvents"
                    :selectedEvent="selectedEvent"
                    @scheduledEventCalendar="scheduledEventCalendar"
                    @deleteEventCalendar="deleteEventCalendar"
                    @closeEvent="closeEvent"/>
              </v-menu>
            </v-sheet>
          </v-col>
        </v-row>
      </v-app>
      <div v-else>
        <TeasingCalendar :isSubUser="isSubUser"/>
      </div>
    </ubi-panel>
  </ubi-page-container>
</template>

<script>
import { mapGetters } from 'vuex'
import UbiPanel from '@/components/Panel.vue'
import DatetimePicker from '@/pages/calendar/components/DatetimePicker.vue'
import ToolbarCalendar from '@/pages/calendar/components/ToolbarCalendar.vue'
import CardModalCalendar from '@/pages/calendar/components/CardModalCalendar.vue'
import TeasingCalendar from '@/pages/calendar/components/TeasingCalendar.vue'
import UbiPageContainer from '@/components/PageContainer.vue'
import { $t } from '@/i18n'
import DoubleBounce from '@/components/spinners/DoubleBounce.vue'
import {
  getFirstAndLastDayFromDate,
  getFirstAndLastDayOfMonth,
  getNextMonthDate,
  getPreviousMonthDate,
  getRangeMonth
} from '@/helpers/functions/convertDate'
import UbiSearchContainer from '@/components/SearchContainer.vue'

export default {
  name: 'Calendar',
  components: {
    UbiSearchContainer,
    DoubleBounce,
    UbiPageContainer,
    UbiPanel,
    DatetimePicker,
    ToolbarCalendar,
    CardModalCalendar,
    TeasingCalendar
  },
  data () {
    return {
      today: new Date().toISOString().substring(0, 10),
      focus: new Date().toISOString().substring(0, 10),
      type: 'month',
      options: [],
      pickerOptionsDateFin: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      name: null,
      details: null,
      end: null,
      color: '#3b5998',
      currentlyEditing: null,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      datetimeDialog: false,
      hasAccess: true,
      editCloseDialog: false,
      monthSelected: ''
    }
  },
  computed: {
    ...mapGetters(['isSubUser']),
    sitimmoUser () {
      return this.$store.state.app.sitimmoUser
    },
    user () {
      return this.$store.state.app.user
    },
    getAllEvents () {
      return this.$store.getters['calendarSocialPosts/getListEvents']
    },
    hasAccessCalendar () {
      // return true
      return this.sitimmoUser.produitCalendrier
    },
    getIsLoading () {
      return this.$store.getters['calendarSocialPosts/getIsLoadingStatus']
    },
    showOptionsWithBv () {
      return (this.sitimmoUser.metier !== 'AGENCE') ? this.options.filter((option) => option.value !== 'IMMO_BIENS_VENDUS') : this.options
    },
    localFilters () {
      return this.$store.getters['calendarSocialPosts/getFilters']
    }
  },
  methods: {
    viewDay ({ date }) {
      this.$router.push({ name: 'calendrier-details', params: { date: date } })
    },
    setToday (args) {
      this.focus = args.today
    },
    setType (args) {
      this.type = args
    },
    closeDialog () {
      this.datetimeDialog = false
    },
    closeEvent (args) {
      this.selectedEvent = args
      this.selectedOpen = false
    },
    deleteEventCalendar (args) {
      const [action, networkEvent] = args
      if (action === 'Delete') {
        this.datetimeDialog = false
        this.$confirm(
          $t('general.calendar.areYouSureYouWantToDeleteYourSchedule'),
          $t('general.calendar.deletionPost'),
          {
            confirmButtonText: $t('general.calendar.acceptedPost'),
            cancelButtonText: $t('general.calendar.refusedPost'),
            type: 'warning'
          }
        ).then(() => {
          try {
            this.selectedOpen = false
            this.$store.dispatch('calendarSocialPosts/deleteScheduled', [networkEvent])
            this.$message({
              type: 'success',
              message: $t('general.calendar.deletionHasBeenCompleted')
            })
          } catch (e) {
            this.$message({
              type: 'error',
              message: $t('general.calendar.deletionFailed')
            })
          }
        })
      }
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }
      nativeEvent.stopPropagation()
    },
    scheduledEventCalendar () {
      this.datetimeDialog = open
    },
    updatedDateTime (args) {
      const [eventSelected, time, date, datetimeDialog] = args
      this.$confirm(
        $t('general.calendar.areYouSureYouWantToChangeYourSchedule'),
        $t('general.calendar.Amendment'),
        {
          confirmButtonText: $t('general.calendar.acceptedPost'),
          cancelButtonText: $t('general.calendar.refusedPost'),
          type: 'warning'
        }
      ).then(() => {
        try {
          if (new Date(date) >= new Date()) {
            this.$store.dispatch('calendarSocialPosts/updateCronExpressionEvent', [eventSelected, time, date])
            this.datetimeDialog = datetimeDialog
            this.date = ''
            this.time = ''
            this.$message({
              type: 'success',
              message: $t('general.calendar.theChangeHasBeenMade')
            })
          } else {
            this.$message({
              type: 'warning',
              message: $t('general.calendar.warningSheduledBefore')
            })
          }
        } catch (e) {
          this.$message({
            type: 'error',
            message: $t('general.calendar.theChangeHasBeenUndone')
          })
        }
      })
    },
    doFilter () {
      this.$store.dispatch('calendarSocialPosts/loadEvents')
    },
    resetfilterCalendar () {
      this.$store.commit('calendarSocialPosts/resetFilters')
      this.$store.dispatch('calendarSocialPosts/loadEvents')
      this.monthSelected = ''
      this.focus = this.today
    },
    prevClicked ({ date }) {
      const selectedDate = getRangeMonth(getPreviousMonthDate(date))
      this.$store.commit('calendarSocialPosts/setFilters', { key: 'startDate', value: selectedDate.startDate })
      this.$store.commit('calendarSocialPosts/setFilters', { key: 'endDate', value: selectedDate.endDate })
      this.$store.dispatch('calendarSocialPosts/loadEvents')
    },
    nextClicked ({ date }) {
      const selectedDate = getRangeMonth(getNextMonthDate(date))
      this.$store.commit('calendarSocialPosts/setFilters', { key: 'startDate', value: selectedDate.startDate })
      this.$store.commit('calendarSocialPosts/setFilters', { key: 'endDate', value: selectedDate.endDate })
      this.$store.dispatch('calendarSocialPosts/loadEvents')
    },
    setSelectedMonthToDates (date) {
      this.focus = date
      const selectedDate = getFirstAndLastDayFromDate(date)
      this.$store.commit('calendarSocialPosts/setFilters', { key: 'startDate', value: selectedDate.startDate })
      this.$store.commit('calendarSocialPosts/setFilters', { key: 'endDate', value: selectedDate.endDate })
      this.$store.dispatch('calendarSocialPosts/loadEvents')
    }
  },
  beforeMount () {
    this.options = [
      {
        label: $t('planning.postsAds'),
        value: this.sitimmoUser.univers
      },
      {
        label: $t('planning.postsBv'),
        value: 'IMMO_BIENS_VENDUS'
      },
      {
        label: $t('planning.postsEdito'),
        value: 'EDITO'
      }
    ]
  },
  mounted () {
    if (this.sitimmoUser.produitCalendrier) {
      this.$store.commit('calendarSocialPosts/resetFilters')
      this.$store.dispatch('calendarSocialPosts/loadEvents')
    }
  }
}
</script>
<style lang="scss" scoped>
.v-application{
    height: 1200px;
}
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #EBF3F2;
  color: #1A4A56;
  border: 1px solid #EAEDF0;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}

.calendar-loader{
  position: relative;
}

.wait-calendar-events{
  width: 100%;
  height: 100%;
  background-color: rgba(15, 55, 65, 0.6);
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  position: absolute;
  top:40%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 800;
  display: flex;
  justify-content: center;
  align-items: center;

  .text-loading-and-loader {
    padding: 10px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: "Dosis", sans-serif;
    z-index: 802;
    p {
    font-size: 16px;
    font-weight: 500;
    color: white;
    margin: 30px 0;
  }
  }
}
</style>
